<template>
  <b-nav-item-dropdown ref="notification-dropdown" class="dropdown-notification mr-25" menu-class="nx-dropdown" right @show="onShow">
    <template #button-content>
      <feather-icon v-bind:badge="totalOfUnreaded" badge-classes="bg-danger" class="text-body" icon="BellIcon" size="21"/>
    </template>

    <!-- Header -->
    <li class="nx-dd__header">
      <div class="nx-dd__title">
        <span class="nx-dd__icon"><feather-icon icon="BellIcon" size="18"/></span>
        <span>{{ $t('navDropdown.notifications') }}</span>
      </div>
      <b-badge pill class="nx-dd__count" v-if="totalOfUnreaded > 0">{{ totalOfUnreaded }}</b-badge>
    </li>

    <!-- Notifications -->
    <li class="nx-dd__list" @scroll="scrollHandle">
      <b-link v-for="notification in notifications" :key="notification.id" class="nx-item">
        <div class="nx-item__avatar">
          <b-avatar size="40" :src="notification.avatar" :text="notification.avatar" :variant="$t(`notifications.${notification.source}.color`)"/>
        </div>
        <div class="nx-item__content">
          <div class="nx-item__title">{{ $t(`notifications.${notification.source}.${notification.content}.title`, notification.params) }}</div>
          <div class="nx-item__body">{{ $t(`notifications.${notification.source}.${notification.content}.body`, notification.params) }}</div>
          <div class="nx-item__time">
            <feather-icon icon="ClockIcon" size="11"/>
            {{ notification.time | moment($t('timeFormat.dateTime.format')) }}
          </div>
        </div>
      </b-link>

      <div v-if="!loading && notifications.length === 0" class="nx-empty">
        <span class="nx-empty__icon"><feather-icon icon="BellIcon" size="26"/></span>
        <span>{{ $t('navDropdown.noNotifications') }}</span>
      </div>
      <div v-if="loading" class="nx-loading"><b-spinner small class="mr-50"/>{{ $t('operations.loading') }}</div>
    </li>

    <!-- Footer -->
    <li class="nx-dd__footer" v-if="notifications.length > 0">
      <b-button variant="flat-primary" size="sm" @click="readAllNotifications">
        <feather-icon icon="CheckCircleIcon" size="14"/>{{ $t('operations.readAllNotifications') }}
      </b-button>
      <b-button variant="flat-danger" size="sm" @click="deleteAllNotifications">
        <feather-icon icon="Trash2Icon" size="14"/>{{ $t('operations.deleteAllNotifications') }}
      </b-button>
    </li>
  </b-nav-item-dropdown>

</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'

import { mapActions, mapGetters } from 'vuex'
import mixinBase from '@/components/mixin/mixinBase'
import mixinTable from '@/components/mixin/mixinTable'

export default {
  components:{VuePerfectScrollbar},
  mixins:[ mixinBase, mixinTable,],
  data:()=>({
    notifications: [],
  }),
  computed:{
    ...mapGetters('notification', ['totalOfUnreaded']),
  },
  methods:{
    ...mapActions('notification', ['getNotifications', 'setAllNotificationsAsRead','setAllNotificationsAsDeleted']),
    onShow(){
      this.pagination.page = 1;
      this.fetchNotifications();
    },
    fetchNotifications() {
      let loadingToken = this.setLoading(true);
      this.getNotifications(this.pagination).then(response=>{
        if(response.pagination.page === 1) {
          this.notifications = response.data
        } else {
          this.notifications = this.notifications.concat(response.data)
        }
        this.setMetaDataFromResult(response);
      }).finally(()=>{
        this.setLoaded(loadingToken);
      })
    },
    scrollHandle(evt) {
      let data = {
        scrollTop: evt.srcElement.scrollTop,
        scrollHeight: evt.srcElement.scrollHeight,
        clientHeight: evt.srcElement.clientHeight,
        scrollBottom: evt.srcElement.scrollTop + evt.srcElement.clientHeight,
        isBottom: evt.srcElement.scrollTop + evt.srcElement.clientHeight >= evt.srcElement.scrollHeight
      }
      if(data.isBottom && !this.loading && this.pagination.page < this.pagination.pages) {
        this.pagination.page++;
        this.fetchNotifications();
      }
    },
    readAllNotifications(){
      this.setAllNotificationsAsRead();
      this.$refs['notification-dropdown'].hide();
    },
    deleteAllNotifications(){
      this.setAllNotificationsAsDeleted();
      this.$refs['notification-dropdown'].hide();
    }
  },
}
</script>

<style>

</style>
